import { CoreMenu } from 'src/@core/types';

export const PMMenu: CoreMenu[] = [
  {
    id: 'projects',
    title: 'Projects',
    type: 'item',
    url: 'app/projects',
    role: {
      roles: ['employee'],
      module: 'projects',
      right: 'view',
    },
  },
  {
    id: 'modules',
    title: 'Modules',
    type: 'item',
    url: 'app/modules',
    role: {
      roles: ['employee'],
      module: 'modules',
      right: 'view',
    },
  },
  {
    id: 'features',
    title: 'Features',
    type: 'item',
    url: 'app/features',
    role: {
      roles: ['employee'],
      module: 'features',
      right: 'view',
    },
  },
  {
    id: 'my-tasks',
    title: 'My Tasks',
    type: 'item',
    url: 'i-team/tasks/self',
    role: {
      roles: ['employee'],
      module: 'my-tasks',
      right: '',
    },
    hidden: false,
  },
  {
    id: 'team-tasks',
    title: 'Team Tasks',
    type: 'item',
    url: 'i-team/tasks/team',
    role: {
      roles: ['employee'],
      module: 'team-tasks',
      right: 'view',
    },
    hidden: false,
  },
  {
    id: 'weekly-planner',
    title: 'Weekly Planner',
    type: 'item',
    url: 'i-team/weekly-planner',
    role: {
      roles: ['employee', 'customer'],
      module: 'weekly-planner',
      right: 'view',
    },
  },
  {
    id: 'qa-test-scenarios',
    title: 'Test Scenarios',
    type: 'item',
    url: 'i-team/qa/test-scenarios',
    role: {
      roles: ['employee'],
      module: 'test-scenario',
      right: 'view',
    },
  },
  {
    id: 'qa-test-activity',
    title: 'Test Activity',
    type: 'item',
    url: 'i-team/qa/test-activity',
    role: {
      roles: ['employee'],
      module: 'test-activity',
      right: 'view',
    },
  },
  {
    id: 'qa-testing-scenarios',
    title: 'Test Results',
    type: 'item',
    url: 'i-team/qa/testing-scenarios',
    role: {
      roles: ['employee'],
      module: 'test-result',
      right: 'view',
    },
  },
  {
    id: 'uat-activity',
    title: 'UAT Activity',
    type: 'item',
    url: 'lead-konnekt/uat/activity',
    role: {
      roles: ['employee', 'customer'],
      module: 'uat-activity',
      right: 'view',
    },
  },
  {
    id: 'chat',
    title: 'Chat',
    type: 'item',
    url: 'app/chat',
    role: {
      roles: ['employee'],
      module: 'chat',
      right: 'view',
    },
  },
];
